// Forms Component
export function initForms() {
  const forms = {
    init() {
      console.log("📝 Forms init started");
      this.initContactForm();
      this.initQuickQuoteForm();
      this.initFormValidation();
    },

    initContactForm() {
      const contactForm = document.getElementById('contact-form');
      if (!contactForm) return;

      // Initialize contact form with new structure
      this.contactForm = {
        form: contactForm,
        submitButton: contactForm.querySelector('button[type="submit"]'),

        bindEvents: function() {
          this.form.addEventListener("submit", this.handleSubmit.bind(this));

          // Real-time validation
          const inputs = this.form.querySelectorAll("input, textarea, select");
          inputs.forEach((input) => {
            input.addEventListener("blur", this.validateField.bind(this));
            input.addEventListener("input", this.validateField.bind(this));
          });
        },

        validateField: function(e) {
          const field = e.target;
          const value = field.value.trim();
          const fieldType = field.type;
          const isRequired = field.hasAttribute("required");

          this.clearFieldError(field);

          if (isRequired && !value) {
            this.showFieldError(field, "Bu alan zorunludur.");
            return false;
          }

          if (fieldType === "email" && value && !forms.isValidEmail(value)) {
            this.showFieldError(field, "Geçerli bir e-posta adresi girin.");
            return false;
          }

          if (fieldType === "tel" && value && !forms.isValidPhone(value)) {
            this.showFieldError(field, "Geçerli bir telefon numarası girin.");
            return false;
          }

          field.classList.add("success");
          return true;
        },

        showFieldError: function(field, message) {
          field.classList.add("error");
          field.classList.remove("success");

          let errorElement = field.parentNode.querySelector(".error-message");
          if (!errorElement) {
            errorElement = document.createElement("div");
            errorElement.className = "error-message text-red-500 text-sm mt-1";
            field.parentNode.appendChild(errorElement);
          }
          errorElement.textContent = message;
        },

        clearFieldError: function(field) {
          field.classList.remove("error", "success");
          const errorElement = field.parentNode.querySelector(".error-message");
          if (errorElement) {
            errorElement.remove();
          }
        },

        validateForm: function() {
          const inputs = this.form.querySelectorAll("input[required], textarea[required], select[required]");
          let isValid = true;

          inputs.forEach((input) => {
            if (!this.validateField({ target: input })) {
              isValid = false;
            }
          });

          return isValid;
        },

        handleSubmit: function(e) {
          e.preventDefault();

          if (!this.validateForm()) {
            this.showMessage("Lütfen tüm alanları doğru şekilde doldurun.", "error");
            return;
          }

          this.setLoading(true);

          const formData = new FormData(this.form);
          const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            service: formData.get('service'),
            message: formData.get('message')
          };

          setTimeout(() => {
            this.setLoading(false);
            this.sendToWhatsApp(data);
          }, 500);
        },

        sendToWhatsApp: function(data) {
          const serviceName = this.form.querySelector('#service option:checked')?.textContent || data.service;
          
          let message = `🏗️ GENSA İNŞAAT - YENİ PROJE TALEBİ\n\n`;
          message += `👤 Ad Soyad: ${data.name}\n`;
          message += `📞 Telefon: ${data.phone}\n`;
          if (data.email) {
            message += `📧 E-posta: ${data.email}\n`;
          }
          message += `🔧 Hizmet: ${serviceName}\n\n`;
          message += `📝 Proje Detayları:\n${data.message}\n\n`;
          message += `📅 Talep Tarihi: ${new Date().toLocaleDateString('tr-TR')}\n`;
          message += `🕐 Saat: ${new Date().toLocaleTimeString('tr-TR')}`;

          const encodedMessage = encodeURIComponent(message);
          const whatsappNumber = '905321667576';
          const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
          
          window.open(whatsappUrl, '_blank');
          
          this.showMessage(
            "Talebiniz WhatsApp'a yönlendirildi. Formu doldurduktan sonra mesajı gönderin.",
            "success"
          );
          
          this.form.reset();
          this.clearAllFieldErrors();
        },

        setLoading: function(loading) {
          if (loading) {
            this.submitButton.classList.add("btn-loading");
            this.submitButton.disabled = true;
          } else {
            this.submitButton.classList.remove("btn-loading");
            this.submitButton.disabled = false;
          }
        },

        showMessage: function(message, type) {
          const existingMessage = this.form.querySelector(".form-message");
          if (existingMessage) {
            existingMessage.remove();
          }

          const messageElement = document.createElement("div");
          messageElement.className = `form-message ${
            type === "success" ? "success-message" : "error-message"
          }`;
          messageElement.textContent = message;

          this.form.insertBefore(messageElement, this.form.firstChild);

          if (type === "success") {
            setTimeout(() => {
              messageElement.remove();
            }, 5000);
          }
        },

        clearAllFieldErrors: function() {
          const fields = this.form.querySelectorAll("input, textarea, select");
          fields.forEach((field) => {
            this.clearFieldError(field);
          });
        }
      };

      // Bind events
      this.contactForm.bindEvents();
    },

    initQuickQuoteForm() {
      const quoteForm = document.getElementById('quote-form');
      if (!quoteForm) return;

      quoteForm.addEventListener('submit', this.handleQuoteSubmit.bind(this));
    },

    initFormValidation() {
      const forms = document.querySelectorAll('form:not(#contact-form)');
      
      forms.forEach(form => {
        const inputs = form.querySelectorAll('input, textarea');
        
        inputs.forEach(input => {
          input.addEventListener('blur', () => this.validateField(input));
          input.addEventListener('input', () => this.clearErrors(input));
        });
      });
    },

    validateField(field) {
      const value = field.value.trim();
      const type = field.type;
      const required = field.hasAttribute('required');
      
      this.clearErrors(field);
      
      if (required && !value) {
        this.showError(field, 'Bu alan zorunludur');
        return false;
      }
      
      if (type === 'email' && value && !this.isValidEmail(value)) {
        this.showError(field, 'Geçerli bir e-posta adresi giriniz');
        return false;
      }
      
      if (type === 'tel' && value && !this.isValidPhone(value)) {
        this.showError(field, 'Geçerli bir telefon numarası giriniz');
        return false;
      }
      
      if (field.name === 'name' && value && value.length < 2) {
        this.showError(field, 'İsim en az 2 karakter olmalıdır');
        return false;
      }
      
      return true;
    },

    showError(field, message) {
      field.classList.add('border-red-500');
      
      const existingError = field.parentNode.querySelector('.error-message');
      if (existingError) {
        existingError.remove();
      }
      
      const errorDiv = document.createElement('div');
      errorDiv.className = 'error-message text-red-500 text-sm mt-1';
      errorDiv.textContent = message;
      field.parentNode.appendChild(errorDiv);
    },

    clearErrors(field) {
      field.classList.remove('border-red-500');
      const errorMessage = field.parentNode.querySelector('.error-message');
      if (errorMessage) {
        errorMessage.remove();
      }
    },

    handleQuoteSubmit(e) {
      e.preventDefault();
      
      const form = e.target;
      const isValid = this.validateForm(form);
      
      if (!isValid) {
        this.showMessage('Lütfen formu eksiksiz doldurunuz', 'error');
        return;
      }
      
      const formData = new FormData(form);
      const message = this.createWhatsAppMessage(formData);
      const whatsappUrl = `https://wa.me/905321667576?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
      
      this.showMessage('WhatsApp üzerinden yönlendiriliyorsunuz...', 'info');
    },

    createWhatsAppMessage(formData) {
      const data = {};
      for (let [key, value] of formData.entries()) {
        data[key] = value;
      }
      
      return `
Merhaba, web sitenizden teklif talebi:

İsim: ${data.name || 'Belirtilmemiş'}
Telefon: ${data.phone || 'Belirtilmemiş'}
E-posta: ${data.email || 'Belirtilmemiş'}
Hizmet: ${data.service || 'Belirtilmemiş'}
Mesaj: ${data.message || 'Belirtilmemiş'}

Geri dönüş bekliyorum. Teşekkürler.
      `.trim();
    },

    validateForm(form) {
      const inputs = form.querySelectorAll('input, textarea');
      let isValid = true;
      
      inputs.forEach(input => {
        if (!this.validateField(input)) {
          isValid = false;
        }
      });
      
      return isValid;
    },

    showMessage(text, type = 'info') {
      const existingMessage = document.querySelector('.form-message');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      const messageDiv = document.createElement('div');
      messageDiv.className = `form-message fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 max-w-sm`;
      
      switch (type) {
        case 'success':
          messageDiv.classList.add('bg-green-500', 'text-white');
          break;
        case 'error':
          messageDiv.classList.add('bg-red-500', 'text-white');
          break;
        case 'info':
        default:
          messageDiv.classList.add('bg-blue-500', 'text-white');
          break;
      }
      
      messageDiv.textContent = text;
      document.body.appendChild(messageDiv);
      
      setTimeout(() => {
        if (messageDiv.parentNode) {
          messageDiv.remove();
        }
      }, 5000);
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    isValidPhone(phone) {
      const phoneRegex = /^(\+90|0)?[5][0-9]{9}$/;
      return phoneRegex.test(phone.replace(/\s/g, ""));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => forms.init());
  } else {
    forms.init();
  }
}

initForms();
